// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"b9160c26","50":"3edb4447","59":"d88916fc","374":"0421ef47","428":"b44b63c6","445":"9d7005db","518":"8cc26426","911":"631d09d0"}[chunkId] + ".chunk.js";
};